import React from "react";
import cx from "classnames";
import { Icon, emailDelivery } from "Icons/index";
import { Link } from "react-router-dom";
import t from "Utils/translation";

const DeliverySpotBanner = ({ hideCTA }) => {
  return (
    <div className={cx("w-auto min-h-8 rounded p-2 flex items-start gap-2 overflow-hidden bg-[--accent-l35]")}>
      <Icon svg={emailDelivery} width="1rem" height="1rem" />

      <div className="flex flex-col self-center">
        <div className="text-sm font-semibold mb-1 text-[--accent-d30] uppercase">{t("banner.tryDelivery.title")}</div>

        <p
          className="text-sm mb-2 text-[--accent-d30]"
          dangerouslySetInnerHTML={{ __html: t("banner.tryDelivery.desc") }}
        ></p>

        {!hideCTA && (
          <Link className="text-sm" to={`/delivery`}>
            {t("banner.tryDelivery.cta")}
          </Link>
        )}
      </div>
    </div>
  );
};

export default DeliverySpotBanner;
